import {FieldValues} from 'react-hook-form';
import Title from '@/components/help/common/Title';
import InquiryNotice from '@/components/help/pc/inquiry/InquiryNotice';
import {FormGroup} from '@/components/help/common/FormContainer';
import {useFormDefaultFieldValues} from '@/hooks/help/useFormDefaultValues';
import {useSubmitForm} from '@/hooks/help/useSubmitForm';
import {FORM_TYPE_INQUIRY, INQUIRY_FIELD_ORDER} from '@/constants/help/index';

// 문의하기 페이지
const HelpInquiry = () => {
  const defaultFieldValues = useFormDefaultFieldValues({
    type: FORM_TYPE_INQUIRY,
  });

  const {mutate: postHelpForm} = useSubmitForm({type: FORM_TYPE_INQUIRY});

  const onSubmit = (data: FieldValues) => {
    postHelpForm(data);
  };

  return (
    <>
      <Title title='문의하기' />
      <InquiryNotice />
      <FormGroup
        onSubmit={onSubmit}
        fieldOrder={INQUIRY_FIELD_ORDER}
        defaultValues={defaultFieldValues}
        type={FORM_TYPE_INQUIRY}>
        <FormGroup.UserId />
        <FormGroup.OsInfo />
        <FormGroup.Email />
        <FormGroup.Category />
        <FormGroup.Title />
        <FormGroup.Content />
        <FormGroup.AttachedFiles />
        <FormGroup.CautionBox />
        <FormGroup.Agreement />
        <FormGroup.ActionButtons />
      </FormGroup>
    </>
  );
};

export default HelpInquiry;
